/** @file invertBatch: the undo commands of a batch, its commands' inverses in reverse order. */
import type { Command } from '../types/command';
import type { CommandOutcome } from './commandDef';

/** Each outcome's `inverse`, last command first, concatenated. */
export function invertBatch(outcomes: readonly CommandOutcome[]): Command[] {
  return [...outcomes].reverse().flatMap((o) => o.inverse);
}
